var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirtableIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_8910)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#1D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.587 85.5252L88.3036 100.952C86.2303 101.81 86.2518 104.756 88.3381 105.583L125.777 120.429C129.066 121.734 132.729 121.734 136.019 120.429L173.458 105.582C175.543 104.756 175.566 101.811 173.492 100.953L136.21 85.5246C132.808 84.1171 128.987 84.1171 125.586 85.5246",
    fill: "#FCB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.219 128.536V165.625C134.219 167.389 135.998 168.597 137.638 167.947L179.356 151.754C179.821 151.57 180.22 151.25 180.502 150.836C180.783 150.422 180.933 149.933 180.933 149.432V112.344C180.933 110.579 179.154 109.372 177.514 110.022L135.796 126.214C135.331 126.399 134.932 126.719 134.651 127.133C134.37 127.547 134.22 128.036 134.219 128.536",
    fill: "#18BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.478 130.45L112.097 136.428L110.84 137.035L84.7042 149.558C83.048 150.357 80.9329 149.15 80.9329 147.309V112.499C80.9329 111.833 81.2743 111.258 81.7321 110.826C81.92 110.639 82.1331 110.479 82.3652 110.351C82.9892 109.976 83.88 109.876 84.6375 110.176L124.27 125.879C126.284 126.678 126.442 129.501 124.478 130.45",
    fill: "#F82B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.478 130.45L112.097 136.428L81.7321 110.825C81.92 110.638 82.1331 110.479 82.3652 110.351C82.9892 109.976 83.88 109.876 84.6375 110.176L124.27 125.879C126.284 126.678 126.442 129.501 124.478 130.45",
    fill: "black",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_8910",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_8910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_8910",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtableIcon);
export default __webpack_public_path__ + "static/media/airtable_icon.1109856bf0fd9708fa3c0ae93e5d7ea2.svg";
export { ForwardRef as ReactComponent };